export enum ReferelCodeActionTypes {
  API_RESPONSE_SUCCESS = "@@referelcode/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@referelcode/API_RESPONSE_ERROR",

  ADD_REFERELCODE = "@@referelcode/ADD_REFERELCODE",
  UPDATE_REFERELCODE = "@@referelcode/UPDATE_REFERELCODE",
}
